<template>
  <div class="navigation-buttons">
    <div class="nav-item"
         @click="handleNavClick('/simulationExam')">
      <div class="nav-icon">
        <van-icon name="coupon-o"
                  size="30"
                  color="#1989fa" />
      </div>
      <div class="nav-label">模拟考试</div>
    </div>
    <div class="nav-item"
         @click="handleNavClick('/examQuestionBank')">
      <div class="nav-icon">
        <van-icon name="newspaper-o"
                  size="30"
                  color="#1989fa" />
      </div>
      <div class="nav-label">试题库</div>
    </div>

    <div class="nav-item"
         @click="handleNavClick('/mistakeNotebook')">
      <div class="nav-icon">
        <van-icon name="failure"
                  size="30"
                  color="#1989fa" />
      </div>
      <div class="nav-label">错题本</div>
    </div>
    <div class="nav-item"
         @click="handleNavClick('/doPracticeQuestions')">
      <div class="nav-icon">
        <van-icon name="todo-list-o"
                  size="30"
                  color="#1989fa" />
      </div>
      <div class="nav-label">抽题练习</div>
    </div>

    <div class="nav-item"
         @click="handleNavClick('/doPracticeMistakesQuestions')">
      <div class="nav-icon">
        <van-icon name="records-o"
                  size="30"
                  color="#1989fa" />
      </div>
      <div class="nav-label">错题练习</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavigationButtons',
  methods: {
    handleNavClick(path) {
      if (!path) return
      this.$router.push({ path })
    }
  },
}
</script>

<style lang="less" scoped>
// 组件3：导航按钮样式
.navigation-buttons {
  display: flex;
  justify-content: space-around;
  padding: 20px 16px;
  background: white;
  margin: 0 16px 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .nav-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;

    .nav-icon {
      width: 60px;
      height: 60px;
      background: #f0f8ff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 8px;
    }

    .nav-label {
      font-size: 14px;
      color: #333;
    }
  }
}
</style>